import Navbar from "@/components/sections/Navbar";
import Hero from "@/components/sections/Hero";
import CrisisBanner from "@/components/sections/CrisisBanner";
import Categories from "@/components/sections/Categories";
import PodcastSection from "@/components/sections/PodcastSection";
import SelfTest from "@/components/sections/SelfTest";
import Testimonials from "@/components/sections/Testimonials";
import Membership from "@/components/sections/Membership";
import Ecosystem from "@/components/sections/Ecosystem";
import FAQ from "@/components/sections/FAQ";
import ContactCTA from "@/components/sections/ContactCTA";
import Footer from "@/components/sections/Footer";

export default function LandingPage() {
  return (
    <main data-testid="landing-page" className="bg-[#0A0A0A] text-[#FAFAFA]">
      <Navbar />
      <Hero />
      <CrisisBanner />
      <Categories />
      <PodcastSection />
      <SelfTest />
      <Testimonials />
      <Membership />
      <Ecosystem />
      <FAQ />
      <ContactCTA />
      <Footer />
    </main>
  );
}
